import { Component, OnInit } from '@angular/core';
import { PopinService } from '../popin.service';
import { Theme } from '../../../decorators/theme.decorator';

@Component({
  selector: 'sc-right-popin',
  styleUrls: ['./right-popin.component.css', './../blackshield.component.css'],
  templateUrl: './right-popin.component.html'
})
export class RightPopinComponent implements OnInit {
  @Theme() theme: string;

  public isPopinDeployed: boolean;

  constructor(private popinService: PopinService) {}

  public ngOnInit() {
    this.popinService.closeRightPopinEmitter.subscribe(() => {
      this.isPopinDeployed = false;
    });
    this.popinService.openRightPopinEmitter.subscribe(() => {
      this.isPopinDeployed = true;
    });
  }
}
